const AlarmClock = () => {
    return (
        <svg width="15" height="15" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.99967 17.5C13.6816 17.5 16.6663 14.5152 16.6663 10.8333C16.6663 7.15139 13.6816 4.16663 9.99967 4.16663C6.31778 4.16663 3.33301 7.15139 3.33301 10.8333C3.33301 14.5152 6.31778 17.5 9.99967 17.5Z" stroke="#EB5757" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M9.99935 7.5V10.8333L11.666 12.5M4.16602 2.5L1.66602 5M18.3327 5L15.8327 2.5M4.99935 15.8333L3.33268 17.5M14.9993 15.8333L16.666 17.5" stroke="#EB5757" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )
}

export default AlarmClock;